import IconButton from '../IconButton.js';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';
import {Tooltip} from '@mui/material';
import {string} from 'prop-types';

export const ImageryLink = ({layer, tooltipPlacement = 'bottom'}) => {
  const [itemType, itemId] = layer.split(':');
  let title, href;
  if (itemType === 'Mosaic') {
    title = 'Open in Basemaps Viewer';
    href = `https://www.planet.com/basemaps/#/mosaic/${itemId}`;
  } else {
    title = 'Open in Explorer';
    href = `https://www.planet.com/explorer/?item=${itemType}::${itemId}`;
  }

  return (
    <Tooltip title={title} placement={tooltipPlacement}>
      <IconButton onClick={() => window.open(href)}>
        <OpenInNewIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

ImageryLink.propTypes = {
  tooltipPlacement: string,
  layer: string,
};
